import { isNullOrUndefined } from '@/utils/comparators'
export default {
  filters: {
    /**
    * Lowercase any string
    */
    toLowerCase: function (value) {
      if (typeof value === 'string') {
        value = value.toLowerCase()
      }
      return value
    },
    currencySymbol: function (value) {
      let currencySymbol

      if (typeof value === 'string') {
        currencySymbol = value.replace(value.match(/[-+]?[0-9]*\.*\,?[0-9]+/)[0], '').replace(' ', '')
      }

      if (currencySymbol === 'AU$') {
        return 'A$'
      } else if (currencySymbol === 'zl') {
        return 'zł'
      } else if (currencySymbol === 'INR') {
        // U+20B9
        return '\u20B9'
      }

      return currencySymbol
    },
    amountFromFormattedBalance: function (value) {
      return typeof value === 'string'
        ? value.match(/[-+]?[0-9]*\.*\,?[0-9]+/)[0]
        : '-'
    },
    /**
    * Replace email addresses in string with mailto links.
    */
    mailtoLinks: function (value) {
      return !isNullOrUndefined(value)
        ? value.replace(/([\w\.\-\pL]+@\w+\.\w+)/g, '<a href=mailto:$1>$1</a>')
        : ''
    },
    cardExpiryDate: function (value) {
      if (!value) {
        return ''
      }

      const date = new Date(value)
      const year = date.getFullYear() % 100
      const month = date.getMonth() + 1
      return month < 10
        ? `0${month}/${year}`
        : `${month}/${year}`
    },
    trim: function (value) {
      if (!value && typeof value !== 'string') {
        return ''
      }

      return value.trim()
    }
  },
  create: function (Vue) {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formatting.js